import { useEffect, useState } from 'react';
import React from 'react';
import './autores.css';
import { useTranslation } from "react-i18next";
import Popup from '../../../components/popupAutor/popupAutor';

import autores_1 from '../../../assets/imgs/libro_bitcoin/CO-AUTOR1.png';
import autores_2 from '../../../assets/imgs/libro_bitcoin/CO-AUTOR2.png';
import arrow from '../../../assets/imgs/libro_bitcoin/btn_arrow.svg';

const Autores = () => {
    const [lang, setLang] = useState(localStorage.getItem('language') || 'es');
    const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
    const [t, i18n] = useTranslation("libroBitcoin");
    const [selectedAuthor, setSelectedAuthor] = useState(null);

    const renderPopupContent = () => {
        switch (selectedAuthor) {
            case 'daniel':
                return (
                    <div class='Pop-up-autor'>
                        <div class='Pop-up-autor-img'>
                            <img src={autores_1} alt="Daniel Jungen" />
                        </div>
                        <div class='Pop-up-autor-text' dangerouslySetInnerHTML={{ __html: t('autores.bio1') }}>
                            </div>
                    </div>
                );
            case 'pascal':
                return (
                    <div class='Pop-up-autor'>
                        <div class='Pop-up-autor-img'>
                            <img src={autores_2} alt="Daniel Jungen" />
                        </div>
                        <div class='Pop-up-autor-text' dangerouslySetInnerHTML={{ __html: t('autores.bio2') }}>
                            
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="landing_bitcoin_autores">
            <div className="landing_bitcoin_autores_content">
                <h3>{t('autores.titulo')}</h3>
                <div className="land_bit_aut">
                    <div className="land_bit_aut-a">
                        <div className="land_bit_profile">
                            <img src={autores_1} alt="Daniel Jungen" />
                        </div>
                        <div className="land_bit_txt">
                            <h4>Daniel Jungen</h4>
                            <p>{t('autores.profesion1')}</p>
                        </div>
                        <div className="land_bit_btn">
                            <a href="#" onClick={e => { e.preventDefault(); setSelectedAuthor('daniel'); }}>
                                <img src={arrow} alt="Ver más" />
                            </a>
                        </div>
                    </div>
                    <div className="land_bit_aut-a land_bit_aut-a-mov">
                        <div className="land_bit_profile">
                            <img src={autores_2} alt="Pascal Hügli" />
                        </div>
                        <div className="land_bit_txt">
                            <h4>Pascal Hügli</h4>
                            <p dangerouslySetInnerHTML={{ __html: t('autores.profesion2') }} />
                        </div>
                        <div className="land_bit_btn">
                            <a href="#" onClick={e => { e.preventDefault(); setSelectedAuthor('pascal'); }}>
                                <img src={arrow} alt="Ver más" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {selectedAuthor && (
                <Popup
                    content={renderPopupContent()}
                    onClose={() => setSelectedAuthor(null)}
                />
            )}
        </div>
    );
};

export default Autores;